import { gql } from '@apollo/client';

export const getCurrentCompanyJobSlotsSubscriptionQuery = gql`
  query getCurrentCompanyJobSlotsSubscription(
    $input: BaseEmployerCommerceInput!
  ) {
    getCurrentCompanyJobSlotsSubscription(input: $input) {
      totalConcurrentJobSlots
      activeConcurrentJobs
      expiryDateTime
      isConcurrentJobsHardLimitReached
      hasUnlimitedConcurrentJobSlots
      planType
      translatedPlanName
      hasCSVDownload
      csvDownloadTypes
      hasVIPMembershipAccess
      hasJobExternalUrl
      activeInventory {
        activeSubscriptionInformation {
          ...activeSubscriptionInformationFragment
        }
      }
      pendingPurchase {
        planType
        totalConcurrentJobSlots
        translatedPlanName
      }
      hasApplicationHistory
    }
  }
`;
